import React from 'react';
import { modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-slate-50 py-14 md:py-20" data-id="element-196" data-mp="100c9f2m1l0zr">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-197" data-mp="zy983mffvlfq">
        <header className="mx-auto max-w-4xl text-center" data-id="element-198" data-mp="l4mrbfjz980b">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-199" data-mp="q264sd8upgr7">
            Système complet :
            <br data-id="element-200" data-mp="1dtbl0tipeb21" />
            <span className="text-blue-600" data-id="element-201" data-mp="1dssd85mrp31q">50 Fiches Visuelles</span>
          </h2>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-202" data-mp="1iqbqb27qb9s3">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-xl bg-white p-6 shadow-sm ring-1 ring-slate-200" data-id="element-203" data-mp="140cw1ajaoihw">
              <div className="flex items-baseline gap-3" data-id="element-204" data-mp="1wpbhohmmm2ry">
                <span className="text-5xl font-extrabold leading-none tracking-tight text-teal-900" data-id="element-205" data-mp="21i4mf5i3hb41">
                  {module.count}
                </span>
                <span className="text-sm font-bold uppercase tracking-wider text-teal-800" data-id="element-206" data-mp="2vdpuvjh1dyh7">fiches</span>
              </div>
              <h3 className="mt-4 text-xl font-extrabold tracking-tight text-slate-900" data-id="element-207" data-mp="355n96z3cd6k5">{module.title}</h3>
              <p className="mt-2 text-slate-600" data-id="element-208" data-mp="30f6vddvlzix9">{module.summary}</p>
              <p className="mt-auto pt-4 font-semibold text-blue-700" data-id="element-209" data-mp="30cu244kehm4w">{module.closing}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}